import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import MultiLayerFilter from '@features/filter/Common/MultiLayerFilter';
import { allFilterPages, formatMultiLayerFilteOptions } from '@features/filter/static/filterUtil';

const BlockCategory = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [selectedMultilevelData, setSelectedMultiLevelData] = useState([]);
	const multiLevelFilterStore = useSelector((store) => store.multiLevelFIlterStore);
	const currentSelectedFilterLevel = multiLevelFilterStore?.currentSelectedFilterLevel;
	const [currentPath, setCurrentPath] = useState('');
	const location = useLocation();

	useEffect(() => {
		const path = location.pathname;
		setCurrentPath(path);
	}, []);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setSelectedMultiLevelData(multiLevelFilterStore?.multiLevelFilters);
	}, [multiLevelFilterStore]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.BLOCK_SUGGESTIONS]: dependentFilterList?.categoryList,
		[allFilterPages.BLOCK_LIBRARY_CARD_VIEW_LIST]: dependentFilterList?.categoryList,
		[allFilterPages.SKETCH_LIST]: dependentFilterList?.categoryList,
		[allFilterPages.PRODUCT_LIST]: dependentFilterList?.subCategoryList,
		[allFilterPages.COSTING_LIST]: dependentFilterList?.subCategoryList,
		[allFilterPages.FAVOURITE_DETAILS]: dependentFilterList?.subCategoryList,
		[allFilterPages.COLLECTION_DETAILS]: dependentFilterList?.subCategoryList,
		[allFilterPages.MY_ORDER]: dependentFilterList?.subCategoryList
	};

	const getGroupedAllThirdLayerOptions = (options = []) => {
		const updatedOptionsWithAll = options.map((item) => {
			const allSubCategories = item.subCategory.flatMap((subCat) => {
				if (!subCat.subCategory) return [];
				return subCat.subCategory.filter((sub) => !String(sub.id).includes('ALL'));
			});

			const allCategoryEntry = {
				name: `All ${item.name}`,
				id: `${item.id}-ALL`,
				count: item?.count,
				label: 3,
				subCategory: [
					{
						name: 'All',
						id: `ALL`,
						count: item?.count,
						categoryId: item?.id,
						label: 4
					},
					...allSubCategories
				]
			};

			return {
				...item,
				subCategory: [
					allCategoryEntry,
					...item.subCategory.filter((sub) => !String(sub.id).includes('ALL'))
				]
			};
		});
		return updatedOptionsWithAll;
	};

	const onFetchData = async () => {
		let dependentList = filterData[filterPageName];
		const options = formatMultiLayerFilteOptions(dependentList) || [];
		const updatedOptionsWithAll = getGroupedAllThirdLayerOptions(options);

		setAllData(updatedOptionsWithAll);
		setData(updatedOptionsWithAll);
	};

	return (
		<MultiLayerFilter
			filterOptions={data}
			selectedField={selectedField}
			selectedMultilevelData={selectedMultilevelData}
			allOptions={allData}
			setFilterOptions={setData}
			currentSelectedFilterLevel={currentSelectedFilterLevel}
			type="BLOCK_CATEGORY"
			isOpenFourthLayerOnSearch={currentPath.includes('/designs/edit') ? false : true}
		/>
	);
};

export default BlockCategory;
